import type { MultiActionsType } from '@atlassian/jira-bulk-operations-common/src/controllers/use-form-submit-state/types.tsx';

export const transformOptionsUsingMultiAction = <Option,>({
	existingOptions,
	options,
	action,
	isEqual,
}: {
	existingOptions: Option[];
	options: Option[];
	action: MultiActionsType;
	isEqual: (option: Option, existingOption: Option) => Boolean;
}): Option[] | null => {
	if (action === 'set') {
		return options;
	}
	if (action === 'add') {
		return [
			...existingOptions.filter((existingOption) =>
				options.some((option) => !isEqual(option, existingOption)),
			),
			...options,
		];
	}
	if (action === 'remove') {
		return existingOptions.filter((existingOption) =>
			options.some((option) => !isEqual(option, existingOption)),
		);
	}

	return null;
};
